import { authSplitApi } from 'redux/helpers/slice.helpers';
import { EProfileUrl } from 'data/urls/profile.url';
import {
  TProfileSearchDB,
  TProfileSearchUI,
  TProfileDb,
  TProfileUi,
  TUpdateProfilePictureUI,
} from 'data/types/profile.types';
import { profileSearchGetConverter } from 'data/converters/profile.converters';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { EPropertyManagementUrl } from 'data/urls/propertyManagement.url';

const URL = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EProfileUrl.PROFILE}`;
export const profileApi = authSplitApi('profileApi', ['profilesSearch', 'profile']).injectEndpoints({
  endpoints: (build) => ({
    getProfilesSearch: build.query<TProfileSearchUI[], void>({
      query() {
        return {
          url: `${URL}/${EProfileUrl.SEARCH}`,
          method: 'GET',
        };
      },
      transformResponse: (data: TProfileSearchDB[]) => data.map((item) => profileSearchGetConverter.fromDb(item)),
      providesTags: ['profilesSearch'], // for caching and update cache
    }),
    getProfile: build.query<TProfileUi, void>({
      query() {
        return {
          url: URL,
          method: 'GET',
        };
      },
      transformResponse: (data: TProfileDb): TProfileUi => data,
      providesTags: ['profile'],
    }),
    updateProfilePicture: build.mutation<void, TUpdateProfilePictureUI>({
      query({ profilePicture, propertyManagerId }) {
        return {
          url: `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EPropertyManagementUrl.PROPERTY_MANAGERS}/${EPropertyManagementUrl.PROFILE_PICTURE}`,
          method: 'PATCH',
          body: { profilePicture, propertyManagerId },
        };
      },
      invalidatesTags: ['profile'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetProfilesSearchQuery, useGetProfileQuery, useUpdateProfilePictureMutation } = profileApi;
